import { useRef } from "react";
import { ArrowRight } from "lucide-react";
import { useCardTilt } from "../hooks/useMousePosition";

const BADGES = {
  0: "Best Seller",
  2: "New Arrivals",
  4: "Best Seller",
};

export default function CategoryCard({ cat, index }) {
  const cardRef = useRef(null);
  const { shine, handleMove, handleLeave } = useCardTilt(cardRef);
  const badge = BADGES[index];

  return (
    <article
      ref={cardRef}
      onMouseMove={handleMove}
      onMouseLeave={handleLeave}
      className="group relative bg-surface border border-border rounded-2xl overflow-hidden transition-[box-shadow,border-color] duration-400 hover:border-accent hover:shadow-xl"
      style={{ transition: "transform 0.15s ease-out, box-shadow 0.4s ease, border-color 0.4s ease" }}
    >
      {badge && (
        <span className="absolute top-3 right-3 z-20 px-2.5 py-1 rounded-full bg-accent text-primary text-[10px] font-bold uppercase tracking-wider">
          {badge}
        </span>
      )}
      {shine.visible && (
        <div
          className="pointer-events-none absolute inset-0 z-10 opacity-30"
          style={{
            background: `radial-gradient(circle at ${shine.x}% ${shine.y}%, rgba(201,162,39,0.35) 0%, transparent 55%)`,
          }}
        />
      )}
      <div className="aspect-video overflow-hidden">
        <img
          src={cat.image}
          alt={cat.name}
          loading="lazy"
          className="w-full h-full object-cover transition-all duration-400 group-hover:scale-[1.08] group-hover:brightness-105"
        />
      </div>
      <div className="p-5 md:p-6">
        <div className="flex items-start justify-between gap-3 mb-2">
          <h3 className="font-serif text-xl font-bold text-primary">{cat.name}</h3>
          <span className="shrink-0 text-[10px] font-semibold uppercase tracking-wider px-2.5 py-1 rounded-full bg-surface-alt text-muted border border-border">
            {cat.skus}
          </span>
        </div>
        <p className="text-sm text-muted line-clamp-3 leading-relaxed">{cat.desc}</p>
        <a
          href="#inquiry"
          className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-accent group/link"
        >
          View Products
          <ArrowRight size={15} className="transition-transform group-hover/link:translate-x-1" />
        </a>
      </div>
    </article>
  );
}
